import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRowsIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13 8.5H3C2.73478 8.5 2.48043 8.60536 2.29289 8.79289C2.10536 8.98043 2 9.23478 2 9.5V12C2 12.2652 2.10536 12.5196 2.29289 12.7071C2.48043 12.8946 2.73478 13 3 13H13C13.2652 13 13.5196 12.8946 13.7071 12.7071C13.8946 12.5196 14 12.2652 14 12V9.5C14 9.23478 13.8946 8.98043 13.7071 8.79289C13.5196 8.60536 13.2652 8.5 13 8.5ZM13 12H3V9.5H13V12ZM13 3H3C2.73478 3 2.48043 3.10536 2.29289 3.29289C2.10536 3.48043 2 3.73478 2 4V6.5C2 6.76522 2.10536 7.01957 2.29289 7.20711C2.48043 7.39464 2.73478 7.5 3 7.5H13C13.2652 7.5 13.5196 7.39464 13.7071 7.20711C13.8946 7.01957 14 6.76522 14 6.5V4C14 3.73478 13.8946 3.48043 13.7071 3.29289C13.5196 3.10536 13.2652 3 13 3ZM13 6.5H3V4H13V6.5Z",
		fill: "currentColor"
	})
});
export default SvgRowsIcon;
